import { Skeleton } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import Stack from '@mui/material/Stack';
import type { InvoicesOverviewsSummary } from '@weft/api-definition';
import { isNullOrUndefined, withDefault } from '@weft/utils';
import React from 'react';
import { Price } from '../../../../components/design/Price';
import { VyInfoCard } from '../../../../components/new-design/surfaces/VyInfoCard';

type InvoicesPageInfoCardsProps = {
  invoicesOverviewsSummary?: InvoicesOverviewsSummary;
};

export const InvoicesPageInfoCards:React.FC<InvoicesPageInfoCardsProps> = ({
  invoicesOverviewsSummary,
}) => {
  const totalAmount = withDefault(invoicesOverviewsSummary?.totalAmount, 0);
  const openAmount = withDefault(invoicesOverviewsSummary?.openAmount, 0);
  const overdueAmount = withDefault(invoicesOverviewsSummary?.overdueAmount, 0);
  const pendingPaymentAmount = withDefault(invoicesOverviewsSummary?.pendingPaymentAmount, 0);
  const paidAmount = withDefault(invoicesOverviewsSummary?.paidAmount, 0);

  return (
    <Stack
      direction="row"
      spacing={2}
    >
      <VyInfoCard
        label='Total'
        variant="filled"
      >
        <Price
          rounded
          variant="subtitle1"
          fontSize="16px"
          lineHeight="28px"
        >
          {isNullOrUndefined(invoicesOverviewsSummary?.totalAmount) ? 
            <Skeleton
              sx={{ backgroundColor: blueGrey[700] }}
              variant="text"
            /> : totalAmount}
        </Price>
      </VyInfoCard>

      <VyInfoCard
        label='Open'
        color="primary"
      >
        <Price
          rounded
          variant="subtitle1"
          fontSize="16px"
          lineHeight="28px"
        >
          {isNullOrUndefined(invoicesOverviewsSummary?.openAmount)
            ? <Skeleton variant="text"/>
            : openAmount}
        </Price>
      </VyInfoCard>

      <VyInfoCard
        label='Overdue'
        color="error"
      >
        <Price
          rounded
          variant="subtitle1"
          fontSize="16px"
          lineHeight="28px"
        >
          {isNullOrUndefined(invoicesOverviewsSummary?.overdueAmount)
            ? <Skeleton variant="text"/>
            : overdueAmount}
        </Price>
      </VyInfoCard>

      <VyInfoCard
        label="Pending"
        color="secondary"
      >
        <Price
          rounded
          variant="subtitle1"
          fontSize="16px"
          lineHeight="28px"
        >
          {isNullOrUndefined(invoicesOverviewsSummary?.pendingPaymentAmount)
            ? <Skeleton variant="text"/>
            : pendingPaymentAmount}
        </Price>
      </VyInfoCard>

      <VyInfoCard
        label="Paid"
        color="success"
      >
        <Price
          rounded
          variant="subtitle1"
          fontSize="16px"
          lineHeight="28px"
        >
          {isNullOrUndefined(invoicesOverviewsSummary?.paidAmount)
            ? <Skeleton variant="text"/>
            : paidAmount}
        </Price>
      </VyInfoCard>
    </Stack>
  );
};